export default "__VITE_ASSET__BZ6$01Um__"